import React from "react";
import { tw } from "@noones/ui/tw";
import { IconArrowRight } from "@noones/ui/icons/mono-no-pixel";
import { defineMessages, FormattedMessage } from "react-intl";
import { Button } from "@noones/ui";

export const TransparancyDashboard = () => (
    <div className={tw.bg_white.mt_4.p_6.rounded_xl.space_y_4}>
        <div className={tw.text_h3.font_semibold}>
            <FormattedMessage {...messages.title} />
        </div>

        <div className={tw.space_y_3}>
            <div className={tw.flex.items_center.gap_2}>
                <IconArrowRight width={20} height={20} className={tw.text_green} />
                <div className={tw.text_body_14.font_normal}>
                    <FormattedMessage {...messages.proof} />
                </div>
            </div>

            <div className={tw.flex.items_center.gap_2}>
                <IconArrowRight width={20} height={20} className={tw.text_green} />
                <div className={tw.text_body_14.font_normal}>
                    <FormattedMessage {...messages.volumep2p} />
                </div>
            </div>

            <div className={tw.flex.items_center.gap_2}>
                <IconArrowRight width={20} height={20} className={tw.text_green} />
                <div className={tw.text_body_14.font_normal}>
                    <FormattedMessage {...messages.partnerProgram} />
                </div>
            </div>

            <div className={tw.flex.items_center.gap_2}>
                <IconArrowRight width={20} height={20} className={tw.text_green} />
                <div className={tw.text_body_14.font_normal}>
                    <FormattedMessage {...messages.resolution} />
                </div>
            </div>
        </div>

        <Button
            size={48}
            mode="green"
            className={tw.w_full}
            component="a"
            href="https://noones.com/transparency-dashboard"
        >
            <FormattedMessage {...messages.dashboard} />
        </Button>
    </div>
);

const messages = defineMessages({
    title: {
        id: "TransparancyDashboard.title",
        defaultMessage: "Transparency dashboard",
        description: "Transparency dashboard",
    },
    proof: {
        id: "TransparancyDashboard.proof",
        defaultMessage: "NoOnes proof of reserves",
        description: "NoOnes proof of reserves",
    },
    volumep2p: {
        id: "TransparancyDashboard.volumep2p",
        defaultMessage: "P2P trading volume",
        description: "P2P trading volume",
    },
    partnerProgram: {
        id: "TransparancyDashboard.partnerProgram",
        defaultMessage: "Partner program rewards",
        description: "Partner program rewards",
    },
    resolution: {
        id: "TransparancyDashboard.resolution",
        defaultMessage: "Dispute resolution time",
        description: "Dispute resolution time",
    },
    dashboard: {
        id: "TransparancyDashboard.dashboard",
        defaultMessage: "Open dashboard",
        description: "Open dashboard button",
    },
});
